
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ErrorHandler', function ($log, $state, Parse) {
		return function(error) {

			// $log.log('Error picked up by error handler');

			if (error.redirect) {
				$state.go(error.redirect);
				return false;
			}

			// Handle invalid Parse session token
			if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
				// $log.log('ErrorHandler: Processing invalid session token error');
				/*
					Problem: The users session has expired or become invalid
					Solution: Log out the user and return them to the login page
				*/

				// TODO: Clean localstorage and session storage too. A new problem has caused the original solution to stop working q

				// Log the user out and return to the login page
				$state.go('accountLogout', { ref: 'login' });

			}

		}
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/errorhandler.service.js